import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { ruRU } from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";

import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import { useEffect } from "react";
import Typography from "@mui/material/Typography";


const theme1 = createTheme();

theme1.typography.h11 = {
  fontSize: "1em",
  fontWeight: "700",
};

theme1.typography.h7 = {
  fontSize: "0.7em",
};


export default function Asynchronous2({
  childToParent,
  clear,
  dataRows,
  name,
  sx,
  value2,
  value3,
  childToParent_id,
  childToParent_id_clear,
  freesl,
  dataParentToChild,
}) {
  const theme = createTheme(ruRU);
  //const [value, setValue] = React.useState("");
  //const [inputValue, setInputValue] = React.useState("");

  const [value, setValue] = React.useState(value2 !== undefined && value2?.length > 1 ? value2 : "");  
  const [valueID, setValueID] = React.useState(value3 !== undefined ? value3 : "");  

  const [inputValue, setInputValue] = React.useState(value2 !== undefined && value2 > 1 ? value2 : "");


  //console.log("1111     " + value2);

  useEffect(() => {
    if (dataRows?.length === 0 && clear === true && (value2 === undefined || (value2 !== undefined && value2.length === 0))) {

      //console.log("22222222222222");

      setValue("");
      setValueID("");
      setInputValue("");
    }
  }, [clear, dataRows, value2]);

  useEffect(() => {
    if (value2 !== undefined && value2.length > 0 && value2 !== "new") {

     // console.log("33333333333333");
            
    //  console.log(" seEffect(() => value2 = " + value2.length);

      setValue(value2);
      setValueID(value3);
      setInputValue(value2);
    }
  }, [value2], );

//console.log(clear)


  return (
    <ThemeProvider theme={theme}>

      <Autocomplete
        value={clear === false ? value : ""}
        onChange={(event, newValue) => {
          

          setValue(newValue);
          childToParent_id(newValue);
          setValueID(newValue);
          console.log("newValue");
          console.log(newValue);
        }}
        inputValue={clear === false ? inputValue : ""}
        onInputChange={(event, newInputValue) => {
          
          console.log("newInputValue")
          console.log(newInputValue)


          setInputValue(newInputValue);
          childToParent(newInputValue);
        }}
        freeSolo={freesl}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        id="free-solo-2-demo"
        disableClearable
        options={dataRows}
        sx={sx}
        renderOption={(props, option) => {
          return (
            <li
              style={{ height: "auto", left: "15px", top: "10px" }}
              {...props}
              key={option.id}
            >
          <ThemeProvider theme={theme1}>
          <div key={option}>
            <Typography variant="h11">{option["name"]}</Typography>
           
            {option["phones"]?.map(
                        (phone) => (
                         // console.log(phone),
                          (
                            <div key={phone + Math.floor(Math.random() * 1000) + 1}>
                              <Typography variant="h7" color="textSecondary">
                                {phone}
                              </Typography>
                            </div>
                          )
                        )
                      )}
                      {option["emails"]?.map(
                        (email) => (
                         // console.log(email),
                          (
                            <div key={email + Math.floor(Math.random() * 1000) + 1}>
                              <Typography variant="h7" color="textSecondary">
                                {email}
                              </Typography>
                            </div>
                          )
                        )
                      )}
                      </div>

          </ThemeProvider>
          </li>

          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={name}
            InputProps={{
              ...params.InputProps,
              type: "text",

              startAdornment: (
                <InputAdornment
                  position="start"
                  onClick={() => {
                    setInputValue("");
                    setValue("");
                    childToParent_id("");
                    childToParent("");
                    childToParent_id_clear(valueID);
                  }}
                >
                  <SearchIcon />
                </InputAdornment>
              ),

              endAdornment: value && (
                <IconButton
                  aria-label="toggle password visibility"
                  sx={{
                    position: "absolute",
                    right: "10px",
                  }}
                  onClick={() => {

                    console.log("value")
                    console.log(valueID)
      

                    setInputValue("");
                    setValue("");
                    childToParent_id("");
                    childToParent("");
                    childToParent_id_clear(valueID);
                  }}
                >
                  <HighlightOffIcon
                    sx={{ position: "absolute", right: "10px" }}
                  />
                </IconButton>
              ),
            }}
          />
        )}
      />
    </ThemeProvider>
  );
}
